import Vue from "vue"
import Router from "vue-router"
import store from "@/stores"
import { HAS_SESSION, IS_ADMINISTRATOR } from "@/stores/application/getters"
import { ROUTE_AFTER_LOGIN_KEY } from "@/constants"

Vue.use(Router)

const anonymousUsersOnly = (to, from, next) => {
    if (!store.getters[HAS_SESSION]) {
        next()
        return
    }

    next("/")
}

const loggedInUsersOnly = (to, from, next) => {
    if (store.getters[HAS_SESSION]) {
        next()
        return
    }

    sessionStorage.setItem(ROUTE_AFTER_LOGIN_KEY, to.path)
    next("/login")
}

const administratorsOnly = (to, from, next) => {
    if (store.getters[IS_ADMINISTRATOR]) {
        next()
        return
    }

    next("/")
}

export default new Router({
    routes: [{
        path: "/login",
        component: () => import("@/views/login"),
        beforeEnter: anonymousUsersOnly
    }, {
        path: "/reset-password",
        component: () => import("@/views/reset-password"),
        beforeEnter: anonymousUsersOnly
    }, {
        path: "/",
        component: () => import("@/views/layout"),
        beforeEnter: loggedInUsersOnly,
        children: [{
            path: "/",
            component: () => import("@/views/overview"),
            beforeEnter: loggedInUsersOnly
        }, {
            path: "/reporting",
            component: () => import("@/views/reporting"),
            beforeEnter: administratorsOnly
        }, {
            path: "/manage/users",
            component: () => import("@/views/manage-users"),
            beforeEnter: administratorsOnly
        }, {
            path: "/manage/usergroups",
            component: () => import("@/views/manage-user-groups"),
            beforeEnter: administratorsOnly
        }, {
            path: "/manage/activity-groups",
            component: () => import("@/views/manage-activity-groups"),
            beforeEnter: administratorsOnly
        }, {
            path: "/manage/activity-groups/:id",
            component: () => import("@/views/manage-activities"),
            beforeEnter: administratorsOnly
        }]
    }, {
        path: "*",
        redirect: "/"
    }]
})